import { useNavigate } from 'react-router-dom';
import { Modal } from '../Modal/Modal';
import { FiCheckCircle, FiAlertCircle, FiAlertTriangle } from 'react-icons/fi';
import './StatusModal.css';

export type StatusModalType = 'success' | 'error' | 'warning';

interface StatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: StatusModalType;
  title: string;
  message: string;
}

export const StatusModal = ({
  isOpen,
  onClose,
  type,
  title,
  message,
}: StatusModalProps) => {
  const navigate = useNavigate();

  const handleAction = () => {
    onClose();
    if (type === 'success') {
      navigate('/products');
    }
  };

  const renderIcon = () => {
    switch (type) {
      case 'success':
        return <FiCheckCircle className="status-modal__icon--success" />;
      case 'error':
        return <FiAlertCircle className="status-modal__icon--error" />;
      case 'warning':
        return <FiAlertTriangle className="status-modal__icon--warning" />;
      default:
        return null;
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="" className="status-modal-wrapper">
      <div className="status-modal">
        <div className="status-modal__icon">
          {renderIcon()}
        </div>
        <h2 className="status-modal__title">{title}</h2>
        <p className="status-modal__message">{message}</p>
        <div className="status-modal__actions">
          <button className="status-modal__close-btn" onClick={handleAction}>
            {type === 'success' ? 'Continue Shopping' : 'Close'}
          </button>
        </div>
      </div>
    </Modal>
  );
};
